module.exports = __webpack_public_path__ + "static/0065-f318379a2dbfa38fda2ed97f13f6a753.png";